import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import dayjs from 'dayjs';
import _ from 'lodash';
export default {
  name: "ResolveDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentId: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'edit' // 'edit' or 'view'
    },
    type: {
      type: String,
      default: 'COMPLAINT'
    }
  },
  data: function data() {
    return {
      isExpanded: false,
      loading: false,
      submitLoading: false,
      info: {},
      form: {
        replyText: '',
        //投诉人消息
        complainedMessage: '',
        //被投诉人消息
        actions: {
          reward: false,
          mute: 0
        }
      },
      rules: {
        replyText: [{
          required: true,
          message: '请输入要发送给投诉人的消息',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    title: function title() {
      return this.mode === 'view' ? '处理记录' : '投诉结案';
    },
    //投诉人
    complainant: function complainant() {
      return this.info.complainant || {};
    },
    //被投诉人
    complained: function complained() {
      return this.info.complained || {};
    },
    //信息
    complaint: function complaint() {
      return this.info.complaint || {};
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;
      if (val) {
        this.getInfo();
        if (this.mode === 'edit') {
          this.form = {
            replyText: '',
            //投诉人消息
            complainedMessage: '',
            //被投诉人消息
            actions: {
              reward: false,
              mute: 0
            }
          };
          this.isExpanded = false;
          this.$nextTick(function () {
            _this.$refs.form.clearValidate();
          });
        } else {
          this.isExpanded = true;
        }
      }
    }
  },
  filters: {
    dateFormat: function dateFormat(value, format) {
      if (!value) return "";
      if (String(value).length === 10) {
        value = value * 1000;
      }
      return dayjs(value).format(format);
    }
  },
  methods: {
    getInfo: function getInfo() {
      var _this2 = this;
      this.loading = true;
      this.$api.getComplaintDetail({
        id: this.currentId
      }).then(function (res) {
        _this2.info = res.data || {};
        if (_this2.mode === 'view') {
          var _this2$info$complaint;
          if (!((_this2$info$complaint = _this2.info.complaint) !== null && _this2$info$complaint !== void 0 && (_this2$info$complaint = _this2$info$complaint.result) !== null && _this2$info$complaint !== void 0 && _this2$info$complaint.actions)) {
            _this2.info.complaint.result.actions = {};
          }
          _this2.form = _.cloneDeep(_this2.info.complaint.result);
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
      this.$refs.form.clearValidate();
    },
    handleSubmit: function handleSubmit() {
      var _this$form$actions,
        _this$complaint,
        _this3 = this;
      //如果当日已经发送过奖励进行提示
      if ((_this$form$actions = this.form.actions) !== null && _this$form$actions !== void 0 && _this$form$actions.reward && (_this$complaint = this.complaint) !== null && _this$complaint !== void 0 && _this$complaint.dailyRewards) {
        this.$confirm('投诉人本日已获得过投诉奖励，请确认是否继续发放并将投诉标记为已处理？', '奖励发放提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(function () {
          _this3.submitData();
        }).catch(function () {});
        return;
      }
      this.submitData();
    },
    submitData: function submitData() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.form.id = _this4.currentId;
          _this4.submitLoading = true;
          _this4.$api.complaintsResolve(_this4.form).then(function () {
            _this4.$emit('confirm');
            _this4.report();
            _this4.handleClose();
          }).finally(function () {
            _this4.submitLoading = false;
          });
        }
      });
    },
    report: function report() {
      var _this$complainant3;
      if (this.form.actions.reward) {
        var _this$complainant;
        this.$operationLog.push({
          operationType: "complaint",
          code: 'reward',
          detailBatchNo: this.currentId,
          userId: (_this$complainant = this.complainant) === null || _this$complainant === void 0 ? void 0 : _this$complainant.userId,
          operationOrderType: this.type
        });
      }
      if (this.form.actions.mute) {
        var _this$complainant2;
        var codeMap = {
          1: 'ban_3_days',
          2: 'permanent_ban',
          3: 'ban_for_fraud'
        };
        this.$operationLog.push({
          operationType: "complaint",
          code: codeMap[this.form.actions.mute],
          detailBatchNo: this.currentId,
          userId: (_this$complainant2 = this.complainant) === null || _this$complainant2 === void 0 ? void 0 : _this$complainant2.userId,
          operationOrderType: this.type
        });
      }
      this.$operationLog.push({
        operationType: "complaint",
        code: 'resolved',
        detailBatchNo: this.currentId,
        userId: (_this$complainant3 = this.complainant) === null || _this$complainant3 === void 0 ? void 0 : _this$complainant3.userId,
        operationOrderType: this.type
      });
    }
  }
};